'use client';

import { useCallback, useEffect, useRef, useReducer, useMemo } from 'react';
import { ATTACHMENTS_TOOLBAR_KEY_EVENT } from '../AttachmentsToolbar.keys';
import { attachmentsToolbarReducer, attachmentsToolbarReducerInitialState } from '../AttachmentsToolbar.reducer';
import { triggerAttachmentToolbarUpdateEvent } from '../AttachmentsToolbar.module';
import { AttachmentsToolbarContextProvider } from '../AttachmentsToolbar.context';
const AttachmentsToolbarContext = ({
  children
}) => {
  const uploadControllers = useRef({});
  const [{
    attachments,
    count
  }, dispatch] = useReducer(useMemo(() => attachmentsToolbarReducer(uploadControllers.current), []), attachmentsToolbarReducerInitialState);
  useEffect(() => {
    const handleAttachmentsToolbarAction = e => {
      dispatch(e?.detail);
    };
    document.addEventListener(ATTACHMENTS_TOOLBAR_KEY_EVENT, handleAttachmentsToolbarAction);
    return () => {
      document.removeEventListener(ATTACHMENTS_TOOLBAR_KEY_EVENT, handleAttachmentsToolbarAction);
    };
  }, []);
  useEffect(() => {
    // Handler function that checks if files are uploading
    /* AUTO ADDED DELETE ME */
    /* eslint-disable-next-line consistent-return */
    function handleBeforeUnload(e_0: BeforeUnloadEvent) {
      if (count.uploading > 0) {
        e_0.returnValue = 'You have files uploading! Are you sure you want to leave?';
        // Alternatively, you could use e.preventDefault(); in some browsers and return a string.
        return 'You have files uploading! Are you sure you want to leave?';
      }
    }

    // Conditionally add event listener based on whether files are uploading
    if (count.uploading > 0) {
      if (typeof window !== 'undefined') {
        window.addEventListener('beforeunload', handleBeforeUnload);
      }
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      }
    };
  }, [count.uploading]);
  const dispatchWithExternalUpdate = useCallback(action => {
    dispatch(action);
    triggerAttachmentToolbarUpdateEvent(action);
  }, []);
  if (count.total === 0 || count.waiting === count.total) {
    return null;
  }
  return <AttachmentsToolbarContextProvider value={{
    attachments,
    count,
    dispatch: dispatchWithExternalUpdate
  }}>
      {children}
    </AttachmentsToolbarContextProvider>;
};
export default AttachmentsToolbarContext;